import { render, staticRenderFns } from "./ShopMain.vue?vue&type=template&id=8d297458&scoped=true"
import script from "./ShopMain.vue?vue&type=script&lang=js"
export * from "./ShopMain.vue?vue&type=script&lang=js"
import style0 from "./ShopMain.vue?vue&type=style&index=0&id=8d297458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_18124a4e9c6dea8cfaa8db968b5e834e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d297458",
  null
  
)

export default component.exports